import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as fromMenu from './menu.actions';

@Injectable()
export class MenuEffects {
  constructor(private actions$: Actions) {}
}
